import icon from "../../assets/moon.svg";
import type { Property } from "../../types";

export const nightVision: Property = {
  id: "nightVision",
  title: "nightVision.title",
  icon,
};
